// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DO NOT EDIT
@todo This file is copied from GUI and should be pulled out into a shared library.
See https://github.com/LLK/scratch-paint/issues/13 */

/* ACTUALLY, THIS IS EDITED ;)
THIS WAS CHANGED ON 10/25/2017 BY @mewtaylor TO ADD A VARIABLE FOR THE SMALLEST
GRID UNITS.

ALSO EDITED ON 11/13/2017 TO ADD IN CONTANTS FOR LAYOUT FROM \`layout-contents.js\`*/

/* layout contants from \`layout-constants.js\`, minus 1px */

.labeled-icon-button_mod-edit-field_Hxk8l {
  background: none;
  border: none;
  display: inline-block;
  padding: 0.25rem 0.325rem;
  outline: none;
  border-radius: 0.25rem;
  min-width: 3rem;
  font-size: 0.85rem;
  text-align: center;
}

.labeled-icon-button_edit-field-icon_hIF2y {
  width: 1.5rem;
  height: 1.5rem;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
  vertical-align: middle;
}

.labeled-icon-button_edit-field-icon_hIF2y.labeled-icon-button_gray_n0AAd {
  -webkit-filter: var(--paint-filter-icon-gray, none);
          filter: var(--paint-filter-icon-gray, none);
}

.labeled-icon-button_edit-field-title_TEgFX {
  display: block;
  margin-top: 0.125rem;
  font-size: 0.625rem;
}
`, "",{"version":3,"sources":["webpack://./../scratch-paint/src/components/labeled-icon-button/labeled-icon-button.css"],"names":[],"mappings":"AAAA;;oDAEoD;;AAEpD;;;;kFAIkF;;AAElF,0DAA0D;;AAE1D;EACE,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,oBAAoB;MAChB,oBAAoB;UAChB,YAAY;EACpB,sBAAsB;AACxB;;AAEA;EACE,mDAAmD;UAC3C,2CAA2C;AACrD;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB","sourcesContent":["/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n/* ACTUALLY, THIS IS EDITED ;)\nTHIS WAS CHANGED ON 10/25/2017 BY @mewtaylor TO ADD A VARIABLE FOR THE SMALLEST\nGRID UNITS.\n\nALSO EDITED ON 11/13/2017 TO ADD IN CONTANTS FOR LAYOUT FROM `layout-contents.js`*/\n\n/* layout contants from `layout-constants.js`, minus 1px */\n\n.mod-edit-field {\n  background: none;\n  border: none;\n  display: inline-block;\n  padding: 0.25rem 0.325rem;\n  outline: none;\n  border-radius: 0.25rem;\n  min-width: 3rem;\n  font-size: 0.85rem;\n  text-align: center;\n}\n\n.edit-field-icon {\n  width: 1.5rem;\n  height: 1.5rem;\n  -webkit-box-flex: 1;\n  -webkit-flex-grow: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  vertical-align: middle;\n}\n\n.edit-field-icon.gray {\n  -webkit-filter: var(--paint-filter-icon-gray, none);\n          filter: var(--paint-filter-icon-gray, none);\n}\n\n.edit-field-title {\n  display: block;\n  margin-top: 0.125rem;\n  font-size: 0.625rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mod-edit-field": `labeled-icon-button_mod-edit-field_Hxk8l`,
	"modEditField": `labeled-icon-button_mod-edit-field_Hxk8l`,
	"edit-field-icon": `labeled-icon-button_edit-field-icon_hIF2y`,
	"editFieldIcon": `labeled-icon-button_edit-field-icon_hIF2y`,
	"gray": `labeled-icon-button_gray_n0AAd`,
	"edit-field-title": `labeled-icon-button_edit-field-title_TEgFX`,
	"editFieldTitle": `labeled-icon-button_edit-field-title_TEgFX`
};
export default ___CSS_LOADER_EXPORT___;
